module.exports = __webpack_public_path__ + "img/Doctor2.4ee39228.png";